import styled, { css } from 'styled-components';
import { BoxShadowLarge } from 'autogen/design-tokens/tokens';
import { breakpoint, zIndex } from 'variables';
import type { CenterDrawerViewProps, Position } from '../shared/types';

const getDrawerSize = (size?: CenterDrawerViewProps['size']) => {
    switch (size) {
        case 'large':
            return css`
                width: 900px;
                max-width: 900px;
            `;
        case 'medium':
            return css`
                width: 100%;
                max-height: 100%;

                ${breakpoint.up('768px')} {
                    max-width: 480px;
                }
            `;
        case 'small':
            return css`
                width: 342px;
                max-width: 342px;
            `;
        default:
            return css`
                width: 100%;
                max-height: 90%;

                ${breakpoint.up('768px')} {
                    max-height: 100%;
                    max-width: 480px;
                }
            `;
    }
};

const rightPlacementStyles = css`
    right: 0;
    top: 0;
    min-height: 100%;
`;

const leftPlacementStyles = css`
    left: 0;
    top: 0;
    min-height: 100%;
`;

const centerPlacementStyles = css`
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const bottomPlacementStyles = css`
    bottom: 0;
    left: 0;
    right: 0;
`;

const fullscreenStyles = css`
    height: 100%;
    max-height: none;
    border-radius: unset;
`;

export const getPlacementPosition = (position: Position) => {
    switch (position) {
        case 'right':
            return rightPlacementStyles;
        case 'left':
            return leftPlacementStyles;
        case 'center':
            return centerPlacementStyles;
        case 'bottom':
            return bottomPlacementStyles;
        default:
            return centerPlacementStyles;
    }
};

export const DrawerViewComponent = styled.div<{
    $position: Position;
    $size?: CenterDrawerViewProps['size'];
    $fullscreen: boolean;
}>`
    display: flex;
    flex-direction: column;
    position: fixed;
    background-color: ${({ theme }) => theme.ColorBackgroundPrimary};
    overflow: hidden;
    overscroll-behavior: contain;
 
    z-index: ${zIndex.modal};
    box-shadow: ${BoxShadowLarge};
    border-radius: 28px 28px 0 0;

    ${breakpoint.up('768px')} {
        border-radius: unset;
    }

    ${({ $size }) => getDrawerSize($size)}

    ${({ $fullscreen }) => $fullscreen && fullscreenStyles}

    ${({ $position }) => getPlacementPosition($position)}
`;

export default DrawerViewComponent;
